import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import i18nData from "components/config/i18n.config";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { UIRouter, UIView } from "@uirouter/react";
import { router } from "../../router";
import { ErrorBoundary, ZendeskWidget } from "components/support";

class AppView extends Component {
  render() {
    return (
      <div className="app">
        <ErrorBoundary>
          <MuiThemeProvider>
            <IntlProvider {...i18nData}>
              <UIRouter router={router}>
                <UIView />
              </UIRouter>
            </IntlProvider>
          </MuiThemeProvider>
          <ZendeskWidget appViewModel={this.props.viewModel} />
        </ErrorBoundary>
      </div>
    );
  }
}

export default AppView;



// WEBPACK FOOTER //
// ./src/components/app/app.view.js